import React, {useState, useRef} from 'react';
import {Button, Tab, Tabs} from "@blueprintjs/core";
import MainSection from "components/Report/Form/MainSection";
import LanguageSection from "components/Report/Form/LanguageSection";
import AppearanceSection from "components/Report/Form/Appearance";
import 'components/Report/style/form.css';

/**
 * <ReportForm> component of report form - display Main, Language, Appearance tabs.  And Save button
 * @param initialData - initial values for form
 * @param onChange - callback function to invoke when user saves form
 * @param documentLoading - true if data is still loading
 */
export default ({initialData, onChange, documentLoading}) => {
  const [values, setValues] = useState({...initialData});
  const buttonRef = useRef(null)


  /** User has clicked the Save/Update button */
  const manualUpdate = () => {
    onChange({...values});
  }

  /** User has clicked the Issue Report button */
  const issueReport = async (suffixes, newValues) => {
    onChange({...(newValues || values)}, suffixes);
  }

  /** User has altered report's text in Language tab */
  const onLanguageChange = (language) => {
    if (language !== values.language) {
      setValues({
        ...values,
        language: language
      })
    }
  }

  return (!!values && !documentLoading) ? (
    <div>
      <Tabs
        animate={true}
        id="reportForm"
      >
        <Tab id="main" title="Main" panel={
          <MainSection values={values} setValues={setValues} update={(suffixes, newValues) => issueReport(suffixes, newValues)} />
        }/>
        <Tab id="language" title="Language" panel={
          <LanguageSection data={values.language} onChange={(v) => onLanguageChange(v)}/>
        } />
        <Tab id="appearance" title="Appearance" panel={<AppearanceSection values={values} setValues={setValues}/>} />
        <Tabs.Expander />
        <Button ref={buttonRef} onClick={() => manualUpdate()} intent="success" icon="refresh">Save / Update PDF View</Button>
      </Tabs>
    </div>
  ) : 'Loading...'
}
